import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles(
    (theme, { isSelected, borderColor }: { isSelected?: boolean; borderColor: string }) => ({
        container: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "10px",
            backgroundColor: isSelected ? theme.colors.gray[0] : "#FFFFFF",
            borderColor: isSelected ? borderColor : theme.colors.gray[3],
            boxShadow: "4px 4px 5px rgba(0, 0, 0, 0.08)",
        },
        title: {
            color: theme.colors.gray[9],
            fontSize: theme.fontSizes.md,
            fontWeight: 900,
            textAlign: "center",
        },
        description: {
            color: theme.colors.gray[7],
            fontSize: theme.fontSizes.sm,
            textAlign: "center",
        },
        contentContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        icon: {
            marginBottom: rem(10),
        },
        unstyledButton: {
            width: "100%",
        },
    }),
)
